const muitypography = {
  gutterBottom: {
    marginBottom: 8
  }
};

export default muitypography